import { permissionKeys } from './Keys';

export const permissionModulesKeys = {
	ChatScreen: [
		permissionKeys.SmsDashboard,
		permissionKeys.SmsTemplate,
		permissionKeys.SmsSender,
		permissionKeys.SmsProvider,
		permissionKeys.SmsReport,
		permissionKeys.SmppProvider,
		permissionKeys.RcsDashboard,
		permissionKeys.RcsProvider,
		permissionKeys.RcsReport,
		permissionKeys.WhatsappDashboard,
		permissionKeys.WhatsappProvider,
		permissionKeys.WhatsappTemplate,
		permissionKeys.WhatsappReport,
		permissionKeys.EmailTemplate,
		permissionKeys.EmailProvider,
		permissionKeys.EmailReport,
		permissionKeys.NlpDashboard,
		permissionKeys.NlpAgent,
	],
	Settings: [
		permissionKeys.User,
		permissionKeys.Skill,
		permissionKeys.Permission,
		permissionKeys.Provider,
		permissionKeys.PhoneNumber,
		permissionKeys.Integration,
		permissionKeys.MissedCallToCampaign,
		permissionKeys.Disposition,
		permissionKeys.Contact,
		permissionKeys.Sound,
		permissionKeys.Break,
		permissionKeys.Dnc,
		permissionKeys.Holiday,
		permissionKeys.Flow,
		permissionKeys.ImportExport,
		permissionKeys.Logs,
		permissionKeys.Account,
		permissionKeys.Region,
	],
	Reports: [
		permissionKeys.VoiceCdrReport,
		permissionKeys.OutboundCdrReport,
		permissionKeys.InboundCdrReport,
		permissionKeys.DncCdrReport,
		permissionKeys.AgentOutboundCdrReport,
		permissionKeys.AgentOutboundDropReport,
		permissionKeys.AgentInboundCdrReport,
		permissionKeys.AgentInboundMissedReport,
		permissionKeys.UserSummaryReport,
		permissionKeys.BreakSummaryReport,
		permissionKeys.DisposeSummaryReport,
		permissionKeys.CallbackReport,
		permissionKeys.BroadcastCdrReport,
		permissionKeys.CpassOutboundCdrReport,
		permissionKeys.CpassInboundCdrReport,
		permissionKeys.WebhookReport,
		permissionKeys.TeamSummaryReport,
		permissionKeys.CampaignSummaryReport,
		permissionKeys.AutoDisposeSummaryReport,
		permissionKeys.AgentHeatMapReport,
		permissionKeys.LeadStatusReport,
		permissionKeys.ContactListCallStatisticsReport,
		permissionKeys.ContactListQualityAssuranceReport,
		permissionKeys.DuplicateLeadIdentificationReport,
	],
};



// WEBPACK FOOTER //
// src/modules/common/utils/Permission/ModulesKeys.js